import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { AppRouter } from '@/app/AppRouter';
import '@/styles/global.css';

const boot = document.getElementById('native-boot');
if (Capacitor.isNativePlatform()) {
  boot?.classList.add('is-native');
} else {
  boot?.remove();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
